import React from "react";
import ReactDOM from "react-dom/client";
import Home from "./routes/Home";
import "@mantine/core/styles.css";
import "./index.css";
import { MantineProvider } from "@mantine/core";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Stats from "./routes/Stats";

const router = createBrowserRouter([
	{
		path: "/",
		element: <Home />
	},
	{
		path: "/stats/:clubName",
		element: <Stats />
	}
]);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<React.StrictMode>
		<MantineProvider
			theme={{
				primaryColor: "teal",
				defaultRadius: "md",
				fontFamily: '"Manrope", "Segoe UI", sans-serif',
				headings: {
					fontFamily: '"Bebas Neue", "Impact", sans-serif'
				}
			}}
		>
			<RouterProvider router={router} />
			<Toaster
				position="top-right"
				toastOptions={{
					duration: 4000,
					style: {
						background: "#0f1a2d",
						color: "#ecf3ff",
						boxShadow: "0 20px 36px -18px rgba(0, 0, 0, 0.7)",
						borderRadius: "12px",
						border: "1px solid rgba(142, 166, 206, 0.25)"
					},
					success: {
						iconTheme: {
							primary: "#22c55e",
							secondary: "#ffffff"
						}
					},
					error: {
						iconTheme: {
							primary: "#ef4444",
							secondary: "#ffffff"
						}
					}
				}}
			/>
		</MantineProvider>
	</React.StrictMode>
);
